export default __webpack_public_path__ + "static/media/naturexplorer.274e6b27.png";